export default __webpack_public_path__ + "static/media/MASK.07d31a67.svg";